import { SelectableItem } from "../../processingActivity/ProcessingActivity.types";

import { useDotLegalQuery, useDotLegalQueryWithKey } from "@common/hooks/dotLegalReactQuery";

export function useSelectablePurposesQuery(disableQuery?: boolean) {
    return useDotLegalQueryWithKey<Array<SelectableItem>>("purposes", "/purposes/selectablePurposes", {
        enabled: !disableQuery,
    });
}
